import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import React, { useEffect, useState } from "react"
import { View, StyleSheet } from "react-native"
import { ActivityIndicator, Divider, List } from "react-native-paper"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { UserService } from "@Services/User.service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { defaultUserInfos, patientActivities } from "./Logic"
import { ProfessionalList } from "./ProfessionalList"
import { fullName } from "@Utils/utils"
import { activities } from "@Screens/Home/DiagnosticConclusion/DiagnosticConclusionLogic"
import ConclusionSkills from "@Screens/Home/DiagnosticConclusion/ConclusionSkills"
import { ConclusionService } from "@Services/Conclusion.Service"
import DiagnosticConclusionProgram from "@Screens/Home/DiagnosticConclusion/DiagnosticConclusionProgram"
import ConclusionItemDetails from "@Screens/Home/DiagnosticConclusion/ConclusionItemDetails/ConclusionItemDetails"
import Constants from "expo-constants"

const { platform } = Constants.expoConfig.extra

export const PatientFolder = () => {
    const user = useRecoilValue(userAtom)
    const [loading, setLoading] = useState(false)
    const [history, setHistory] = useState(null)
    const [activitiesPatient, setActivityPatient] = useState(patientActivities)
    const [patientInfo, setPatientInfo] = useState(defaultUserInfos(user))

    const getPatientFolder = () => {
        console.log("patientInfo", patientInfo)
        setLoading(true)
        UserService.getPatientFile(user.id)
            .then((response) => {
                const data = response.data?.data
                setLoading(false)
                if (data) {
                    setPatientInfo((old) => ({
                        ...old,
                        fullName: {
                            ...patientInfo.fullName,
                            value: fullName(data?.patient?.firstName, data?.patient?.lastName)
                        },
                        height: {
                            ...patientInfo.height,
                            value: `${data?.patient?.height?.value ?? "(non renseigné)"} ${
                                data?.patient?.height?.unit ?? ""
                            }`
                        },
                        weight: {
                            ...patientInfo.weight,
                            value: `${data?.patient?.weight?.value ?? "(non renseigné)"} ${
                                data?.patient?.weight?.unit ?? ""
                            }`
                        },
                        age: {
                            ...patientInfo.age,
                            value: `${data?.patient?.age ?? "(non renseigné)"}`
                        }
                    }))
                    setActivityPatient((old) => ({
                        ...old,
                        physicalActivity: {
                            ...activitiesPatient.physicalActivity,
                            description: data?.physicalActivity
                        },
                        levelGroup: { ...activitiesPatient.levelGroup, description: data?.levelGroup },
                        barriers: { ...activitiesPatient.barriers, description: data?.barriers },
                        representations: { ...activitiesPatient.representations, description: data?.representations },
                        goals: { ...activitiesPatient.goals, description: data?.goals },
                        levers: { ...activitiesPatient.levers, description: data?.levers },
                        motivation: { ...activitiesPatient.motivation, description: data?.motivation },
                        skills: { ...activitiesPatient.skills, description: data?.skills }
                    }))
                    setHistory(data?.historic)
                }
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
                setLoading(false)
            })
    }

    useEffect(() => {
        const abortController = new AbortController()
        getPatientFolder()
        return () => {
            abortController.abort()
        }
    }, [])

    const isCpts = platform === "cpts"
    const patientId = user?.id
    const [fetching, setFetching] = useState(true)
    const [conclusion, setConclusion] = useState({})
    const [selectedConclusion, setselectedConclusion] = useState({
        label: "",
        details: "",
        subtitle: ""
    })
    const [isModalVisible, setIiModalVisible] = useState(false)
    const toggleModal = () => setIiModalVisible(!isModalVisible)
    const handleFetchConclusion = () => {
        setFetching(true)
        ConclusionService.getPatientConclusion(patientId)
            .then((res) => {
                const data = res?.data?.data
                const resume = data[data.length - 1]
                setConclusion(resume)
                setFetching(false)
            })
            .catch(() => setFetching(false))
    }

    useEffect(() => {
        handleFetchConclusion()
    }, [])

    const handlePressConclusion = (element) => {
        setselectedConclusion({
            label: element?.title,
            details: element?.description,
            subtitle: element?.subtitle ?? ""
        })
        toggleModal()
    }

    return (
        <ContainerStackScreen>
            {loading ? (
                <ActivityIndicator color={baseColors.green.primary} style={{ padding: 30 }} size={"large"} />
            ) : (
                <CustomScrollview>
                    <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                        Fiche patient
                    </BreeSerifText>

                    <Spacer height={15} />

                    <OpenSansText fontSize={16}>Retrouvez toutes vos informations médicales.</OpenSansText>

                    <View style={styles.content}>
                        <List.Section>
                            {Object.keys(patientInfo).map((key, index) => (
                                <View key={index}>
                                    <List.Item
                                        titleStyle={styles.titleStyle}
                                        descriptionStyle={styles.descriptionStyle}
                                        title={patientInfo[key].title}
                                        description={patientInfo[key].value}
                                    />
                                    {index < 3 && <Divider style={styles.divider} />}
                                </View>
                            ))}
                        </List.Section>
                    </View>

                    <View style={styles.content}>
                        {fetching ? (
                            <ActivityIndicator style={{ marginTop: 50 }} color={baseColors.orange.primary} size={50} />
                        ) : (
                            <>
                                <View style={styles.content}>
                                    {activities(conclusion).map((item, index) => {
                                        if (item?.isSkills || item.isGoals) {
                                            return (
                                                <View key={index}>
                                                    <ConclusionSkills
                                                        isGoals={item.isGoals}
                                                        title={item?.title}
                                                        skills={item?.skills}
                                                        goals={item?.goals}
                                                    />
                                                    <Divider style={styles.divider} />
                                                </View>
                                            )
                                        }

                                        return (
                                            <List.Section key={index}>
                                                <List.Item
                                                    descriptionNumberOfLines={3}
                                                    style={{ paddingHorizontal: 18 }}
                                                    title={item.title}
                                                    titleStyle={{
                                                        marginBottom: 10,
                                                        fontSize: 14,
                                                        fontFamily: baseFontFamily.OpenSansSemiBold,
                                                        color: baseColors.green.primary
                                                    }}
                                                    description={
                                                        item.description === "" ? "(non renseigné)" : item.description
                                                    }
                                                    descriptionStyle={{
                                                        fontSize: 12,
                                                        fontFamily: baseFontFamily.OpenSansSemiBold,
                                                        color: baseColors.black
                                                    }}
                                                    onPress={() =>
                                                        item?.isPressable ? handlePressConclusion(item) : undefined
                                                    }
                                                />
                                                <Divider
                                                    style={{
                                                        height: 2,
                                                        backgroundColor: baseColors.orange.primary,
                                                        width: "90%",
                                                        alignSelf: "center"
                                                    }}
                                                />
                                            </List.Section>
                                        )
                                    })}
                                </View>

                                <Spacer height={20} />

                                <DiagnosticConclusionProgram isPatientFiche conclusion={conclusion} />

                                <ConclusionItemDetails
                                    isModalVisible={isModalVisible}
                                    toggleModal={toggleModal}
                                    selectedConclusion={selectedConclusion}
                                />
                            </>
                        )}
                    </View>

                    {history && (
                        <View style={[styles.content, { padding: 15 }]}>
                            <BreeSerifText fontWeight={"bold"} fontSize={20}>
                                Votre Historique :
                            </BreeSerifText>
                            <Spacer height={5} />
                            <OpenSansText fontSize={16}>{history}</OpenSansText>
                        </View>
                    )}

                    <Spacer height={20} />

                    <ProfessionalList />

                    <Spacer height={20} />
                </CustomScrollview>
            )}
        </ContainerStackScreen>
    )
}

const styles = StyleSheet.create({
    divider: { height: 1, backgroundColor: baseColors.green.primary, width: "90%", alignSelf: "center" },
    titleStyle: {
        marginBottom: 10,
        fontSize: 14,
        fontFamily: baseFontFamily.OpenSansSemiBold,
        color: baseColors.green.primary
    },
    descriptionStyle: {
        fontSize: 14,
        lineHeight: 30,
        fontFamily: baseFontFamily.OpenSansRegular,
        color: baseColors.black
    },
    content: {
        marginTop: 18,
        backgroundColor: baseColors.green.light,
        borderRadius: 10
    }
})
